import React from 'react';
import { StyleSheet, css } from 'aphrodite';

const styles = StyleSheet.create({
  wrap: {},
});

const SearchBuildingName = (props) => {
  return (
    null
  );
}

export default SearchBuildingName;


// WEBPACK FOOTER //
// ./src/contents/SearchBuildingName.jsx